import { useState } from 'react';
import { useJhaToday, useSubmitJha } from '../../hooks/useJhaToday.js';
import { useError } from '../shared/ErrorBanner.jsx';

// Daily safety form. Renders nothing if the user has already submitted today.
// Otherwise sits above the clock widget and refuses to let it work until
// submitted (server enforces this with 412 jha_required, this is the UX layer).
export default function JhaGate() {
  const { data, isLoading } = useJhaToday();
  const submit = useSubmitJha();
  const { show } = useError();
  const [answers, setAnswers] = useState({});

  if (isLoading) return null;
  if (data?.submitted) return null;
  if (!data?.template) return null;

  const setAns = (id, v) => setAnswers(a => ({ ...a, [id]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await submit.mutateAsync(answers);
    } catch (err) {
      show(err.message);
    }
  };

  return (
    <div className="panel" style={{ borderLeft: '3px solid var(--orange)' }}>
      <h3 className="panel-title">
        <span><i className="ph ph-shield-check" /> Daily JHA — required before clock-in</span>
        <span className="badge orange">v{data.template.version}</span>
      </h3>
      <form onSubmit={onSubmit}>
        {data.template.questions.map(q => (
          <JhaQuestion key={q.id} q={q} value={answers[q.id]} onChange={v => setAns(q.id, v)} />
        ))}
        <button className="btn-sm primary" type="submit" disabled={submit.isPending}>
          {submit.isPending ? 'Submitting…' : 'Submit JHA'}
        </button>
      </form>
    </div>
  );
}

function JhaQuestion({ q, value, onChange }) {
  return (
    <div className="field">
      <label className="field-label">
        {q.text}{q.required && <span style={{ color: 'var(--orange)' }}> *</span>}
      </label>
      {q.type === 'yesno' && (
        <div style={{ display: 'flex', gap: 8 }}>
          {['yes', 'no'].map(v => (
            <button key={v} type="button"
              className={'btn-sm' + (value === v ? ' primary' : '')}
              onClick={() => onChange(v)}>{v.toUpperCase()}</button>
          ))}
        </div>
      )}
      {q.type === 'text' && (
        <textarea className="field-textarea"
          value={value || ''} onChange={e => onChange(e.target.value)}
          required={q.required} />
      )}
      {q.type === 'ack' && (
        <label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 13 }}>
          <input type="checkbox"
            checked={!!value}
            onChange={e => onChange(e.target.checked)} />
          <span style={{ color: 'var(--on-surface-variant)' }}>I acknowledge</span>
        </label>
      )}
      {q.type === 'choice' && (
        <select className="field-select"
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          required={q.required}>
          <option value="">—</option>
          {(q.options || []).map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      )}
    </div>
  );
}
